'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.passApplication = passApplication;
exports.passApplicationOnly = passApplicationOnly;
exports.passAuthenticationState = passAuthenticationState;
exports.passDomains = passDomains;
exports.getDomainNameAndModelName = getDomainNameAndModelName;
exports.modelNames2Models = modelNames2Models;
exports.passModels = passModels;
exports.getDomainNameAndServiceName = getDomainNameAndServiceName;
exports.serviceNames2Models = serviceNames2Models;
exports.passNotificationUtils = passNotificationUtils;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(component) {
    return component.displayName || component.name || 'Component';
};

function passApplication(BaseComponent) {
    return passAuthenticationState(passApplicationOnly(BaseComponent));
}

function passApplicationOnly(BaseComponent) {
    var WithApplication = function (_Component) {
        _inherits(WithApplication, _Component);

        function WithApplication() {
            _classCallCheck(this, WithApplication);

            return _possibleConstructorReturn(this, (WithApplication.__proto__ || Object.getPrototypeOf(WithApplication)).apply(this, arguments));
        }

        _createClass(WithApplication, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(BaseComponent, _extends({}, this.props, {
                    application: _auroraJavascriptUtils.assert.object(this.context.utApplication)
                }));
            }
        }]);

        return WithApplication;
    }(_react.Component);

    WithApplication.contextTypes = {
        utApplication: _propTypes2.default.object.isRequired
    };
    WithApplication.displayName = 'WithApplication(' + getDisplayName(BaseComponent) + ')';

    WithApplication.getWrappedInstance = function () {
        return BaseComponent;
    };

    return (0, _hoistNonReactStatics2.default)(WithApplication, BaseComponent);
}

function passAuthenticationState(BaseComponent) {
    var WithAuthenticationState = function (_Component2) {
        _inherits(WithAuthenticationState, _Component2);

        function WithAuthenticationState() {
            var _ref;

            var _temp, _this2, _ret;

            _classCallCheck(this, WithAuthenticationState);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = WithAuthenticationState.__proto__ || Object.getPrototypeOf(WithAuthenticationState)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = { isAuthenticated: false }, _temp), _possibleConstructorReturn(_this2, _ret);
        }

        _createClass(WithAuthenticationState, [{
            key: 'render',
            value: function render() {
                var utApplication = this.context.utApplication;

                return _react2.default.createElement(BaseComponent, _extends({}, this.props, {
                    authenticationState: utApplication.authorization.getAuthenticationState()
                }));
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this3 = this;

                var application = _auroraJavascriptUtils.assert.object(this.context.utApplication);
                var authenticationState = application.authorization.getAuthenticationState();
                this._onChange = function () {
                    return _this3.setState({ isAuthenticated: authenticationState.isAuthenticated });
                };
                authenticationState.on('change:isAuthenticated', this._onChange);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var authenticationState = this.context.utApplication.authorization.getAuthenticationState();
                this._onChange && authenticationState.off('change:isAuthenticated', this._onChange);
            }
        }]);

        return WithAuthenticationState;
    }(_react.Component);

    WithAuthenticationState.contextTypes = {
        utApplication: _propTypes2.default.object.isRequired
    };
    WithAuthenticationState.displayName = 'WithAuthenticationState(' + getDisplayName(BaseComponent);

    WithAuthenticationState.getWrappedInstance = function () {
        return BaseComponent;
    };

    return WithAuthenticationState;
}

function passDomains(domainsNames) {
    _auroraJavascriptUtils.assert.array(domainsNames);

    return function (BaseComponent) {
        var WithApplication = function (_Component3) {
            _inherits(WithApplication, _Component3);

            function WithApplication() {
                _classCallCheck(this, WithApplication);

                return _possibleConstructorReturn(this, (WithApplication.__proto__ || Object.getPrototypeOf(WithApplication)).apply(this, arguments));
            }

            _createClass(WithApplication, [{
                key: 'render',
                value: function render() {
                    var application = _auroraJavascriptUtils.assert.object(this.context.utApplication);

                    var domains = domainsNames.reduce(function (result, name) {
                        return _extends({}, result, _defineProperty({}, name, application.getDomain(name)));
                    }, {});

                    return _react2.default.createElement(BaseComponent, _extends({}, this.props, { domains: domains }));
                }
            }]);

            return WithApplication;
        }(_react.Component);

        WithApplication.contextTypes = {
            utApplication: _propTypes2.default.object.isRequired
        };
        WithApplication.displayName = 'WithDomains(' + getDisplayName(BaseComponent) + ')';

        WithApplication.getWrappedInstance = function () {
            return BaseComponent;
        };

        return (0, _hoistNonReactStatics2.default)(WithApplication, BaseComponent);
    };
}

var validateModelName = function validateModelName(modelName) {
    if (!/[a-zA-Z0-9]+\.[a-zA-Z0-9]+/.test(modelName)) {
        throw new Error('wrong or unknown model name \'' + modelName + '\'');
    }
};

function getDomainNameAndModelName(domainAndModelName) {
    validateModelName(domainAndModelName);

    var _domainAndModelName$s = domainAndModelName.split('.'),
        _domainAndModelName$s2 = _slicedToArray(_domainAndModelName$s, 2),
        domainName = _domainAndModelName$s2[0],
        modelName = _domainAndModelName$s2[1];

    return {
        domainName: domainName,
        modelName: modelName
    };
}

function getModelFromApplication(application, domainAndModelName) {
    var _getDomainNameAndMode = getDomainNameAndModelName(domainAndModelName),
        domainName = _getDomainNameAndMode.domainName,
        modelName = _getDomainNameAndMode.modelName;

    var domain = application.getDomain(domainName);
    var model = domain.getModel(modelName);

    return {
        modelName: modelName,
        model: model
    };
}

function modelNames2Models(application, modelNames) {
    return modelNames.reduce(function (result, name) {
        var _getModelFromApplicat = getModelFromApplication(application, name),
            modelName = _getModelFromApplicat.modelName,
            model = _getModelFromApplicat.model;

        result[modelName] = model;
        return result;
    }, {});
}

function passModels(modelNames) {
    _auroraJavascriptUtils.assert.array(modelNames);

    modelNames.forEach(validateModelName);

    return function (BaseComponent) {
        var WithApplication = function (_Component4) {
            _inherits(WithApplication, _Component4);

            function WithApplication() {
                _classCallCheck(this, WithApplication);

                return _possibleConstructorReturn(this, (WithApplication.__proto__ || Object.getPrototypeOf(WithApplication)).apply(this, arguments));
            }

            _createClass(WithApplication, [{
                key: 'render',
                value: function render() {
                    var application = _auroraJavascriptUtils.assert.object(this.context.utApplication);

                    return _react2.default.createElement(BaseComponent, _extends({}, this.props, {
                        models: modelNames2Models(application, modelNames)
                    }));
                }
            }]);

            return WithApplication;
        }(_react.Component);

        WithApplication.contextTypes = {
            utApplication: _propTypes2.default.object.isRequired
        };
        WithApplication.displayName = 'WithModels(' + getDisplayName(BaseComponent) + ')';

        WithApplication.getWrappedInstance = function () {
            return BaseComponent;
        };

        return (0, _hoistNonReactStatics2.default)(WithApplication, BaseComponent);
    };
}

function validateServiceName(domainAndServiceName) {
    if (!/[a-zA-Z0-9]+\.[a-zA-Z0-9]+/.test(domainAndServiceName)) {
        throw new Error('wrong or unknown service name \'' + domainAndServiceName + '\'');
    }
}

function getDomainNameAndServiceName(domainAndServiceName) {
    validateServiceName(domainAndServiceName);

    var _domainAndServiceName = domainAndServiceName.split('.'),
        _domainAndServiceName2 = _slicedToArray(_domainAndServiceName, 2),
        domainName = _domainAndServiceName2[0],
        serviceName = _domainAndServiceName2[1];

    return {
        domainName: domainName,
        serviceName: serviceName
    };
}

function getServiceFromApplication(application, domainAndServiceName) {
    var _getDomainNameAndServ = getDomainNameAndServiceName(domainAndServiceName),
        domainName = _getDomainNameAndServ.domainName,
        serviceName = _getDomainNameAndServ.serviceName;

    var domain = application.getDomain(domainName);
    var service = domain.getService(serviceName);

    return {
        serviceName: serviceName,
        service: service
    };
}

function serviceNames2Models(application, servicesNames) {
    return servicesNames.reduce(function (result, name) {
        var _getServiceFromApplic = getServiceFromApplication(application, name),
            serviceName = _getServiceFromApplic.serviceName,
            service = _getServiceFromApplic.service;

        result[serviceName] = service;
        return result;
    }, {});
}

function passNotificationUtils(BaseComponent) {
    var WithNotification = function (_Component5) {
        _inherits(WithNotification, _Component5);

        function WithNotification() {
            _classCallCheck(this, WithNotification);

            return _possibleConstructorReturn(this, (WithNotification.__proto__ || Object.getPrototypeOf(WithNotification)).apply(this, arguments));
        }

        _createClass(WithNotification, [{
            key: 'render',
            value: function render() {
                var application = _auroraJavascriptUtils.assert.object(this.context.utApplication);

                return _react2.default.createElement(BaseComponent, _extends({}, this.props, {
                    notificationUtils: _auroraJavascriptUtils.assert.object(application.notificationUtils)
                }));
            }
        }]);

        return WithNotification;
    }(_react.Component);

    WithNotification.contextTypes = { utApplication: _propTypes2.default.object.isRequired };
    WithNotification.displayName = 'WithNotification(' + getDisplayName(BaseComponent) + ')';

    WithNotification.getWrappedInstance = function () {
        return BaseComponent;
    };

    return (0, _hoistNonReactStatics2.default)(WithNotification, BaseComponent);
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/contextUtils.js
// module id = 99
// module chunks = 118